import React, { useEffect, useRef } from "react";
import axios from "axios";
import { baseurl } from "../../baseurl";

const PageCount = ({ pageName }) => {
  const executedRef = useRef(false); // Prevent second run in React Strict Mode

  useEffect(() => {
    if (executedRef.current) return; // Already executed → don't run again
    executedRef.current = true;

    const storedToken = localStorage.getItem("token");

    let validToken = null;
    if (storedToken) {
      try {
        const payload = JSON.parse(atob(storedToken.split(".")[1]));
        if (payload.exp * 1000 > Date.now()) validToken = storedToken;
      } catch {}
    }

    const getDeviceType = () => {
      const ua = navigator.userAgent;
      if (/mobile/i.test(ua)) return "Mobile";
      if (/tablet/i.test(ua)) return "Tablet";
      return "Desktop";
    };

    const getBrowser = () => {
      const ua = navigator.userAgent;
      if (ua.includes("Chrome")) return "Chrome";
      if (ua.includes("Firefox")) return "Firefox";
      if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
      if (ua.includes("Edg")) return "Edge";
      return "Unknown";
    };

    const getOS = () => {
      const ua = navigator.userAgent;
      if (ua.includes("Win")) return "Windows";
      if (ua.includes("Mac")) return "MacOS";
      if (ua.includes("Linux")) return "Linux";
      if (/Android/i.test(ua)) return "Android";
      if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
      return "Unknown";
    };

    const sendPageCount = async () => {
      try {
        const ipRes = await axios.get("https://api.ipify.org?format=json");
        const ip = ipRes?.data?.ip || "Unknown";

        const now = new Date();
        const visitedAtIST = new Date(now.getTime() + 5.5 * 3600 * 1000)
          .toISOString()
          .replace("Z", "+05:30");

        const headers = {};
        if (validToken) {
          headers.Authorization = `Bearer ${validToken}`;
        }

        const payloadData = {
          page_name: pageName,
          ip_address: ip,
          visited_at: visitedAtIST,
          os: getOS(),
          browser: getBrowser(),
          device_type: getDeviceType(),
          user_agent: navigator.userAgent,
          language: navigator.language,
          screen_resolution: `${window.screen.width}x${window.screen.height}`,
          window_size: `${window.innerWidth}x${window.innerHeight}`,
        };

        // console.log("📌 Analytics Payload Sent:", payloadData);

        await axios.post(`${baseurl}savePageVisit`, payloadData, { headers });

        // console.log("✅ Page analytics sent successfully");
      } catch (error) {
        console.error("❌ Page Analytics Error:", error);
      }
    };

    sendPageCount();
  }, [pageName]);

  return null;
};

export default PageCount;
